export const isProductVersionValid = (value: string): boolean => !!value && /^(\d*\.){3,3}\d*$/.test(value);